import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';

function RequestEstimate() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    date: null,
    products: {
      Carpet: false,
      HardWood: false,
      Glasstile: false,
      LuxuryVinyl: false,
      Tile: false,
      Vinyl: false,
      Metaltile: false,
      NaturalStones: false,
    },
    comment: '',
    keepMeUpdated: false,
  });

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prevFormData) => ({
      ...prevFormData,
      date: date,
    }));
  };

  const handleCheckboxChange = (checkboxName) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      products: {
        ...prevFormData.products,
        [checkboxName]: !prevFormData.products[checkboxName],
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const formresponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/form`, formData);
      alert(formresponse.data.data1);
      window.location.reload();
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const inputClass =
    'w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-[#803333]/30 focus:border-[#803333] outline-none transition-colors placeholder-gray-400';

  const sectionTitleClass =
    'text-lg font-bold text-gray-900 border-b border-gray-100 pb-2 mb-4';

  return (
    <div className="bg-gray-50 py-10 md:py-14 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2">
            Request an Estimate
          </h1>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto m-0">
            Meet with one of our skilled project specialists to get started on your flooring project
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 md:p-8">
          <form onSubmit={handleSubmit} className="space-y-8">
            <section>
              <h2 className={sectionTitleClass}>Personal Information</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="firstname" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                    First Name *
                  </label>
                  <input
                    type="text"
                    id="firstname"
                    placeholder="Enter your first name"
                    value={formData.firstName}
                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                    required
                    className={inputClass}
                  />
                </div>
                <div>
                  <label htmlFor="lastname" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                    Last Name *
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    placeholder="Enter your last name"
                    value={formData.lastName}
                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                    required
                    className={inputClass}
                  />
                </div>
                <div>
                  <label htmlFor="phoneNumber" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    placeholder="(417) 847-2484"
                    value={formData.phoneNumber}
                    onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                    required
                    className={inputClass}
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className={inputClass}
                  />
                </div>
              </div>
            </section>

            <section>
              <h2 className={sectionTitleClass}>Project Address</h2>
              <div className="space-y-4">
                <div>
                  <label htmlFor="address" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                    Street Address *
                  </label>
                  <input
                    type="text"
                    id="address"
                    placeholder="1234 Main Street"
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    required
                    className={inputClass}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label htmlFor="city" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                      City *
                    </label>
                    <input
                      type="text"
                      id="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                      required
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label htmlFor="state" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                      State *
                    </label>
                    <input
                      type="text"
                      id="state"
                      placeholder="State"
                      value={formData.state}
                      onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                      required
                      className={inputClass}
                    />
                  </div>
                  <div>
                    <label htmlFor="zip" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                      ZIP Code *
                    </label>
                    <input
                      type="text"
                      id="zip"
                      placeholder="65625"
                      value={formData.zip}
                      onChange={(e) => setFormData({ ...formData, zip: e.target.value })}
                      required
                      className={inputClass}
                    />
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className={sectionTitleClass}>Preferred Date</h2>
              <label className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                Consultation date
              </label>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                placeholderText="Select a date"
                className={inputClass}
                dateFormat="MM/dd/yyyy"
                isClearable
                minDate={new Date()}
              />
            </section>

            <section>
              <h2 className={sectionTitleClass}>Products of Interest</h2>
              <p className="text-sm text-gray-500 mb-3">
                Select all products you&apos;re interested in:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                {Object.keys(formData.products).map((productName) => (
                  <label
                    key={productName}
                    className={`flex items-center gap-2.5 rounded-lg border px-3 py-3 text-sm cursor-pointer transition-colors ${
                      formData.products[productName]
                        ? 'border-[#803333] bg-[#803333]/5 text-[#803333]'
                        : 'border-gray-200 text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <input
                      type="checkbox"
                      id={productName}
                      checked={formData.products[productName]}
                      onChange={() => handleCheckboxChange(productName)}
                      className="accent-[#803333]"
                    />
                    <span className="font-medium">
                      {productName.replace(/([A-Z])/g, ' $1').trim()}
                    </span>
                  </label>
                ))}
              </div>
            </section>

            <section>
              <h2 className={sectionTitleClass}>Additional Information</h2>
              <label htmlFor="comment" className="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1.5">
                Comments or Special Requests *
              </label>
              <textarea
                id="comment"
                rows="4"
                placeholder="Tell us about your project, room size, timeline, or any specific requirements..."
                value={formData.comment}
                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                required
                className={`${inputClass} resize-none`}
              />
            </section>

            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                id="keepMeUpdated"
                checked={formData.keepMeUpdated}
                onChange={() =>
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    keepMeUpdated: !prevFormData.keepMeUpdated,
                  }))
                }
                className="mt-1 accent-[#803333]"
              />
              <span className="text-sm text-gray-600">
                Keep me up to date with exclusive offers, promotions, and flooring tips.
              </span>
            </label>

            <div>
              <button
                type="submit"
                className="w-full text-white font-semibold py-3.5 px-6 rounded-lg border-0 hover:opacity-90 transition-opacity"
                style={{ backgroundColor: '#803333' }}
              >
                Send Request
              </button>
              <p className="text-center text-xs text-gray-500 mt-3 mb-0">
                We&apos;ll contact you within 24 hours to schedule your consultation
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RequestEstimate;
